import HttpClient from "@/common/boot/HttpClient"

const listarCtrlStatus = async ({ commit }, payload) => {

  commit('CARREGANDO', true);
    await HttpClient.get('/ctrl-status', { params: payload }).then(response => {
        commit('LISTAR_DADOS', response.data.data);
        return response;
    });
  commit('CARREGANDO', false);
}

const excluirCtrlStatus = async ({ commit }, payload) => {
    commit('CARREGANDO', true);

    try {
        await Promise.all(
            payload.map(item => excluir(item))
        );
    } finally {
        commit('CARREGANDO', false);
    }
}

const excluir = async(linha) => {
  const resp = await HttpClient.delete(`/ctrl-status/${linha.id}`).then(response => { return response; });
  return resp;
}

const salvarCtrlStatus = async ({ commit,dispatch }, payload) => {

  commit('CARREGANDO', true);

  return await HttpClient.post('/ctrl-status', payload).then(response => {
    dispatch('listarCtrlStatus');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const recuperarCtrlStatus = ({ commit, state }, payload) => {

  commit('CARREGANDO', true);

  const item = state.items.filter(item => item.id === payload.id);

  if(item.length) {
    commit('INSERIR_ITEM_SELECIONADO', ...item);
    return true;
  }

  commit('CARREGANDO', false);

  return false;
}

const atualizarCtrlStatus = async ({ commit,dispatch }, payload) => {
  commit('CARREGANDO', true);

  return await HttpClient.put(`/ctrl-status/${payload.id}`, payload).then(response => {
    dispatch('listarCtrlStatus');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  })
}

const restaurarCtrlStatus = async ({ commit }, payload) => {
    commit('CARREGANDO', true);

    return await HttpClient.post(`/ctrl-status/${payload}/restaurar/`).then(response => {
        return response;
    }).finally(() => {
        commit('CARREGANDO', false);
    });
}

export {
  listarCtrlStatus,
  excluirCtrlStatus,
  salvarCtrlStatus,
  recuperarCtrlStatus,
  atualizarCtrlStatus,
  restaurarCtrlStatus,
}